import { RefreshTokenParams } from '@repo/user-types'
import { AxiosInstance, AxiosResponse } from 'axios'

export const refreshToken = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: RefreshTokenParams
}): Promise<AxiosResponse<void>> => {
  return api.post<void>('/devices/refresh-token', params)
}
